import React from 'react'
import DashboardContainer from '../../containers/dashboard/DashboardContainer'

const DashboardViewPage = () => {
  return <DashboardContainer/>
}

export default DashboardViewPage